import React, { useState } from 'react';

/** Photo with graceful fallback to initials. */
export default function DoctorAvatar({ doctor, primary, size = 'md' }) {
  const [failed, setFailed] = useState(false);
  const sizes = {
    sm: 'h-12 w-12 text-base',
    md: 'h-16 w-16 text-xl',
    lg: 'h-24 w-24 text-3xl',
    xl: 'h-32 w-32 text-4xl',
  };
  const cls = sizes[size] || sizes.md;
  const initial = doctor.initial || (doctor.name || 'D').replace(/^Dr\.?\s*/i, '')[0]?.toUpperCase() || 'D';

  if (doctor.photo_url && !failed) {
    return (
      <img
        src={doctor.photo_url}
        alt={doctor.name}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        className={`${cls} rounded-2xl object-cover object-top flex-shrink-0 ring-2 ring-white/10`}
      />
    );
  }

  return (
    <div
      className={`${cls} rounded-2xl flex items-center justify-center font-bold text-white flex-shrink-0`}
      style={{ background: primary }}
      aria-hidden
    >
      {initial}
    </div>
  );
}
